import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import orderBy from "lodash/orderBy";
import { Button, Dropdown, Icon, Input, Menu, Modal, Switch, Tabs, Table, Typography } from "antd";

import moment from "moment";

import { diseaseService } from "./../../../redux/services";

import ModalCreate from "./create";
import ModalEdit from "./edit";

const config = {
	title           : "Doenças",
	orderByField    : "created_at",
	orderBySort     : "desc",
	permissionPrefix: "diseases",
};

class Index extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading          : false,
			data               : [],
			dataRaw            : [],
			orderByField       : config.orderByField,
			orderBySort        : config.orderBySort,
			search             : "",
			// Actions
			createModalVisible : false,
			editModalVisible   : false,
			// Images
			imagePreviewVisible: false,
			imagePreviewImage  : "",
		};
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll();
	}

	menuMain = () => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".create") && <Menu.Item key="store">
				<a onClick={this.createOpen}>
					<Icon type="plus" />Cadastrar
				</a>
			</Menu.Item>}
		</Menu>
	);

	menu = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="edit">
				<a onClick={() => this.editOpen(item)}>
					<Icon type="edit" />Editar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<Icon type="delete" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	columns = () => {
		let columns = [
			{
				title    : "ID",
				key      : "id",
				dataIndex: "id",
				width    : 90,
				sorter   : true,
				fixed    : "left",
			},
			{
				title    : "",
				key      : "recommendation.images",
				dataIndex: "recommendation.images[0].file_sizes.admin_listing",
				width    : 70,
				sorter   : false,
				className: "image disable-sort",
				render   : (text, item) => {
					if( !text )
					{
						return null;
					}

					return (
						<a onClick={() => this.onImagePreview(item.recommendation.images[0])}>
							<img src={text} style={{ maxHeight: "69px" }} />
						</a>
					)
				}
			},
			{
				title    : "Nome",
				key      : "recommendation.name",
				dataIndex: "recommendation.name",
				width    : 350,
				sorter   : true,
			},
			{
				title    : "ID do item",
				key      : "recommendation.id",
				dataIndex: "recommendation.id",
				width    : 120,
				sorter   : true,
			},
			{
				title    : "Tipo do item",
				key      : "recommendation_type",
				dataIndex: "recommendation_type",
				width    : 180,
				sorter   : true,
			},
			{
				title    : "Recomendação AgroApp",
				key      : "is_highlighted",
				dataIndex: "is_highlighted",
				width    : 220,
				sorter   : true,
				render   : (text) => text ? "Sim" : "Não"
			},
			{
				title           : "Criação",
				key             : "created_at",
				dataIndex       : "created_at",
				width           : 150,
				sorter          : true,
				defaultSortOrder: "descend",
				render          : (text) => moment(text).format("DD/MM/YYYY HH:mm"),
			},
			{
				title    : "Últ. modificação",
				key      : "updated_at",
				dataIndex: "updated_at",
				width    : 160,
				sorter   : true,
				render   : (text) => moment(text).format("DD/MM/YYYY HH:mm"),
			},
		];

		if( this.props.permissions.includes(config.permissionPrefix + ".edit") || this.props.permissions.includes(config.permissionPrefix + ".delete") )
		{
			columns.push({
				title    : "Ações",
				key      : "actions",
				width    : 78,
				className: "actions disable-sort",
				fixed    : window.innerWidth > 767 ? "right" : false,
				render   : (text, item) => (
					<Dropdown overlay={this.menu(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon="more" />
					</Dropdown>
				),
			});
		}

		return columns;
	};

	fetchGetAll = () => {
		const {item} = this.props;

		this.setState({
			isLoading: true,
		});

		diseaseService.getRecommendations({
			owner_id: item.id,
		})
		.then((response) => {
			let data = response.data.data.map(item_ => {
				if( item_.recommendation_type === "defensive" )
				{
					item_.recommendation_type = "Defensivo";
				}
				else if( item_.recommendation_type === "fertilizer" )
				{
					item_.recommendation_type = "Fertilizante";
				}
				else if( item_.recommendation_type === "leaf_fertilizer" )
				{
					item_.recommendation_type = "Fertilizante foliar";
				}

				return item_;
			});

			this.setState({
				isLoading: false,
				data     : data,
				dataRaw  : data,
			});
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
			});
		});
	};

	filterList = () => {
		this.setState(state => {
			let newDate = [...state.dataRaw];

			if( state.search )
			{
				let search = state.search.toLowerCase();

				newDate = newDate.filter(item => {
					if( String(item.recommendation.name).toLowerCase().indexOf(search) !== -1 )
					{
						return true;
					}
					else if( String(item.recommendation.id).toLowerCase().indexOf(search) !== -1 )
					{
						return true;
					}
					else if( String(item.recommendation_type).toLowerCase().indexOf(search) !== -1 )
					{
						return true;
					}

					return false;
				});
			}

			return {
				isLoading: false,
				data     : orderBy(newDate, [state.orderByField], [state.orderBySort]),
			}
		});
	};

	handleTableChange = (pagination, filters, sorter) => {
		this.setState(state => ({
			orderByField: sorter.field ? sorter.field : config.orderByField,
			orderBySort : sorter.order === "descend" ? "desc" : "asc",
		}), () => {
			this.filterList();
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.filterList();
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if( !e["type"] )
		{
			const {search} = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if( search )
				{
					this.filterList();
				}
			});
		}
	};

	/**
	 * Create
	 */
	createOpen = () => {
		const {item} = this.props;

		this.setState({createModalVisible: true});

		// On open screen
		this.createScreen.onOpen(item.id);
	};

	createOnClose = () => {
		this.setState({createModalVisible: false});
	};

	createOnComplete = () => {
		this.setState({createModalVisible: false});

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Edit
	 *
	 * @param id
	 */
	editOpen = ({id}) => {
		const {item} = this.props;

		this.setState({editModalVisible: true});

		// On open screen
		this.editScreen.onOpen(item.id, id);
	};

	editOnClose = () => {
		this.setState({editModalVisible: false});
	};

	editOnComplete = () => {
		this.setState({editModalVisible: false});

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Delete
	 *
	 * @param id
	 */
	deleteConfirm = ({id}) => {
		const {item} = this.props;

		Modal.confirm({
			title  : "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText : "Excluir",
			onOk   : () => {
				return this.deleteConfirmed(item.id, id);
			}
		});
	};

	deleteConfirmed = (owner_id, id) => {
		return diseaseService.destroyRecommendation({
			owner_id,
			id,
		})
		.then((response) => {
			// Fecth all
			this.fetchGetAll();
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
			});
		});
	};

	/**
	 * Image preview
	 */
	onImagePreviewClose = () => this.setState({imagePreviewVisible: false});

	onImagePreview = (media) => {
		this.setState({
			imagePreviewImage  : media.file,
			imagePreviewVisible: true,
		});
	};

	render() {
		return (
			<div>
				<div className="page-content" key="1">
					<div className="page-listing-header">
						<div className="search">
							<Input.Search
								placeholder="Pesquisar"
								onSearch={this.onSearch}
								onChange={this.onSearchChange}
								enterButton
								allowClear
							/>
						</div>
						{(this.props.permissions.includes(config.permissionPrefix + ".create")) && (
							<div className="actions">
								<Dropdown className="actions-dropdown" placement="bottomRight" trigger={["click"]} overlay={this.menuMain}>
									<Button type="primary" icon="more" />
								</Dropdown>
							</div>
						)}
					</div>
					{this.state.search && <Typography.Paragraph>Buscando por <Typography.Text mark>{this.state.search}</Typography.Text></Typography.Paragraph>}
					<Table
						className="page-listing-body"
						columns={this.columns()}
						rowKey="id"
						bordered
						scroll={{x: 1350}}
						dataSource={this.state.data}
						pagination={false}
						loading={this.state.isLoading}
						onChange={this.handleTableChange}
						footer={() => `Total ${this.state.data.length} de registros encontrados.`}
					/>
				</div>
				<ModalCreate
					wrappedComponentRef={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
				<ModalEdit
					wrappedComponentRef={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<Modal className="modal-image" visible={this.state.imagePreviewVisible} footer={null} destroyOnClose={true} onCancel={this.onImagePreviewClose}>
					<img src={this.state.imagePreviewImage} />
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps)(Index);
